module.exports = __webpack_public_path__ + "static/store_apple.e7ddcc40.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/store_apple.png
// module id = 1163
// module chunks = 35783957827783